import {
  COMMAND_ADD_REQUEST,
  COMMAND_ADD_REQUEST_SUCCESS,
  COMMAND_ADD_REQUEST_FAILURE,
  COMMAND_FETCH_REQUEST,
  COMMAND_FETCH_REQUEST_SUCCESS,
  COMMAND_FETCH_REQUEST_FAILURE,
  COMMAND_CLEAN_REQUEST,
  COMMAND_CLEAN_CRUD_REQUEST,
  COMMAND_TYPES_REQUEST,
  COMMAND_TYPES_REQUEST_SUCCESS,
  COMMAND_TYPES_REQUEST_FAILURE,
  COMMAND_TYPES_CLEAN_REQUEST,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  CRUDErrors: {},
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
};

const TYPES_INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const commandsReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case COMMAND_FETCH_REQUEST:
    case COMMAND_ADD_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case COMMAND_FETCH_REQUEST_SUCCESS:
    case COMMAND_ADD_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
        pagination: {
          current: action.data.currentPage,
          pageSize: action.data.pageSize,
          total: action.data.totalRecord,
          totalPage: action.data.totalPage,
          showSizeChanger: true,
        },
      });

    case COMMAND_FETCH_REQUEST_FAILURE:
    case COMMAND_ADD_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case COMMAND_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        CRUDErrors: {},
        pagination: {
          current: 0,
          pageSize: 0,
          total: 0,
          totalPage: 0,
        },
      });

    case COMMAND_CLEAN_CRUD_REQUEST:
      return Object.assign({}, state, {
        CRUDErrors: {},
      });

    default:
      return state;
  }
};

export const commandTypesReducer = (state, action) => {
  state = state || TYPES_INITIAL_STATE;

  switch (action.type) {
    case COMMAND_TYPES_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case COMMAND_TYPES_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
        pagination: {
          current: action.data.currentPage,
          pageSize: action.data.pageSize,
          total: action.data.totalRecord,
          totalPage: action.data.totalPage,
          showSizeChanger: true,
        },
      });

    case COMMAND_TYPES_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case COMMAND_TYPES_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        pagination: {
          current: 0,
          pageSize: 0,
          total: 0,
          totalPage: 0,
        },
      });

    default:
      return state;
  }
};

export default commandsReducer;
